import { useState, useCallback } from 'react';

export function useGetCarouselRef() {
  const [sliderRef, setSliderRef] = useState({ current: null });
  const sliderRefCallback = useCallback((node) => {
    if (!node) return;
    setSliderRef({ current: node });
  }, []);

  const [containerRef, setContainerRef] = useState({ current: null });
  const containerRefCallback = useCallback((node) => {
    if (!node) return;
    setContainerRef({ current: node });
  }, []);

  return { sliderRefCallback, sliderRef, containerRef, containerRefCallback };
}
